import React, {ReactElement, ReactNode} from "react";

import debounce from 'lodash/debounce';
import { Button } from "antd";

import './collapsible.css';


// maxRowNum, content
const Collapsible = ({maxRowNum, children}: {maxRowNum: number, children: ReactNode}) => {
  const [hasClampClass, setHasClampClass] = React.useState(true);
  const [showButton, setShowButton] = React.useState(true);
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {

    // when .clamp is applied, it should have clientHeight!=scrollHeight
    const checkAndSetButtonAvailability = () => {
      const n = containerRef.current;
      if (n) { // if it points to an instance

        const hadClampClass = n.classList.contains("clamp");

        // temporally add the clamp class to test whether it need the more/less button
        // if not do this, when user resize the window wider after click more, then narrow the window, the less button will disappear 
        if(!hadClampClass){
          n.classList.add('clamp');
          n.style.webkitLineClamp=`${maxRowNum}`;
        }
        const { clientHeight, scrollHeight } = n; // scrollHeight: the height of content;
                                                  // clientHeight: the inner height of the element
                                                  
        if(clientHeight!==scrollHeight){ // means it is clamped if the clamp class is applied
            setShowButton(true);
        }else{
            setShowButton(false);
        }
        if(!hadClampClass){
          n.classList.remove('clamp');
          n.style.webkitLineClamp='';
        }
      }
    };

    const debouncedCheckAndSet = debounce(checkAndSetButtonAvailability, 50); //debounce for 50 ms

    checkAndSetButtonAvailability();

    window.addEventListener("resize", debouncedCheckAndSet);

    return () => {
      window.removeEventListener("resize", debouncedCheckAndSet);
    };
  }, [containerRef]);

  return <>
      <div
        ref={containerRef}
        className={hasClampClass? "clamp":""}
        style={{WebkitLineClamp:hasClampClass?maxRowNum:undefined}}
      >
        {children}
      </div>
      {showButton && <Button
          type="link"
          onClick={()=>setHasClampClass(hasCC=>!hasCC)}
          style={{
            height: 22,
            padding: 0,
            borderRadius: 0,
            borderWidth: 0,
          }}
        >
          show {hasClampClass ? "more" : "less"}
        </Button>
      }
    </>;
    
};

export default Collapsible;
